/**
 * Which numbered step of docs/09-BUILD-PLAN.md Phase 6 delivers each screen.
 *
 * Only used to label the placeholders, so an editor clicking a sidebar entry
 * that is not built yet is told when it will be rather than meeting a blank
 * page. An entry disappears from here when its module lands.
 *
 * Two screens in §2's route table have no numbered step of their own:
 *
 *   - `/projects` and `/vacancies`. The build plan's list jumps from "clubs"
 *     to "faculties" and never names them, though §2 routes both and §3 grants
 *     `projects.*` and `vacancies.*` to the Content Editor. They are folded in
 *     with the other simple content modules at step 5. TO CONFIRM.
 *   - `/profile`. §2 gives it to every authenticated user and §5's screen list
 *     does not cover it; it is grouped with users and roles at step 13.
 */
export const MODULE_STEPS: Record<string, number> = {
  vocationalPrograms: 10,
  vocationalContacts: 10,

  users: 13,
  roles: 13,
  activity: 13,
  profile: 13,

  /*
   * Step 15 by the plan's numbering, but it is the one entry whose wait is not
   * a step of this phase: the console is a UI over the `wp:*` commands and
   * those are written in Phase 7. `placeholder.notes.migration` says so
   * instead of quoting this number.
   */
  migration: 15,
};
